module.exports = __webpack_public_path__ + "static/media/close.b25fb533.svg";